<template>
    <div class="import-columns" :class="{loading: loading}">
        <div class="columns" v-if="Array.isArray(summary) && summary.length">
            <div class="row">
                <div class="col-xs-6 col-md-4 col-lg-3 form-group"
                     v-for="importColumn in models"
                     :key="importColumn.id">
                    <import-column
                        :ref="'importColumn-' + importColumn.column"
                        @afterSave="afterSave(false)"
                        :model-id="importColumn.id"
                        :sample="getSampleData(importColumn.column)"
                        :options="attributeOptions"
                    >
                    </import-column>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import models from "./mixins/models";
    import ImportColumn from "./ImportColumn";

    export default {
        mixins: [ models ],

        components: { ImportColumn },

        props: {
            importManifest: {
                required: true,
                type: Object
            },
        },

        computed: {
            url(){
                return '/api/importColumns?archived=true&import_manifest_id=' + this.importManifest.id + '&sort_by=column&sort_dir=ASC';
            },

            modelComponent(){
                return 'importColumns';
            },

            resourceKey(){
                return 'ImportColumns';
            },

            attributeOptions(){
                let allocatedAttributes = _.reduce( this.$refs, ( carry, ref ) => {
                    let model = _.get( ref, '0.model' );
                    if( model && model.deleted_at === null && model.attribute ){
                        carry.push( model.attribute );
                    }

                    return carry;
                }, [] );

                this.attributeOptionsUpdater; // Only need to reference the variable for it to force recalc

                let results = _.reduce( this.attributes, ( carry, label, attribute ) => {
                    let disabled = _.indexOf( allocatedAttributes, attribute ) !== -1;

                    carry.push( {
                        'value': attribute,
                        'label': label,
                        'disabled': disabled
                    } );

                    return carry;
                }, [] );

                return _.sortBy( results, 'label' );
            }
        },

        methods: {
            beforeLoad(){
                return this.loadSampleData();
            },

            getModelsData(){
                return {
                    attributeOptionsUpdater: 1, // A little hack to get the attributeOptions to trigger recalc

                    summary: [],

                    attributes: {
                        'resident.first_name': 'First Name',
                        'resident.last_name': 'Last Name',
                        'resident.full_name': 'Full Name',
                        'resident.email': 'Email',
                        'resident.phone': 'Phone',
                        'resident.phone_2': 'Phone 2',
                        'resident.external_id': 'Resident External',
                        'resident.address': 'Address',
                        'resident.address_2': 'Address 2',
                        'resident.city': 'City',
                        'resident.state': 'State',
                        'resident.postal_code': 'Postal Code',
                        'resident.provider_company_id': 'Provider',
                        'lease.unit': 'Unit',
                        'lease.external_id': 'Lease External',
                        'lease.move_in_at': 'Move In',
                        'lease.move_out_at': 'Move Out',
                        'lease.start_at': 'Lease Start',
                        'lease.end_at': 'Lease End',
                        'lease.government_assistance': 'Gov. Assist.',
                    }
                };
            },

            loadSampleData(){
                return axios.get( '/api/importManifests/' + this.importManifest.id + '/summary' )
                    .then( ( response ) => {
                        this.$set( this, 'summary', response.data.data );
                    } );
            },

            getSampleData( index ){
                if( this.summary ){
                    return _.map( this.summary, ( row ) => {
                        let result = _.nth( row, index );

                        if( _.isObject( result ) ){
                            result = moment.utc( _.get( result, 'date' ) );
                        }

                        return result;
                    } );
                }
            },

            updateAttributeOptions(){
                this.attributeOptionsUpdater++;
            }
        }
    }
</script>
